import {
  MessageResponseDto,
  GetClinicScheduleDto,
  CreateClinicScheduleDto,
  UpdateClinicScheduleDto,
  DeleteClinicScheduleDto,
  ClinicScheduleControllerGet200Response,
  ClinicScheduleApiFp,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseClinicScheduleModel =
  ClinicScheduleControllerGet200Response;
export type GetClinicScheduleModel = GetClinicScheduleDto;
export type MutateResponseClinicScheduleModel = MessageResponseDto;
export type CreateClinicScheduleModel = CreateClinicScheduleDto;
export type UpdateClinicScheduleModel = UpdateClinicScheduleDto;
export type DeleteClinicScheduleModel = DeleteClinicScheduleDto;

export const apiClinicScheduleFp = ClinicScheduleApiFp(apiConfig);
export const getClinicScheduleController =
  apiClinicScheduleFp.clinicScheduleControllerGet;
export const getWeeklyScheduleController =
  apiClinicScheduleFp.clinicScheduleControllerGetWeeklySchedule;
export const getPublicWeeklyScheduleController =
  apiClinicScheduleFp.clinicScheduleControllerGetPublicWeeklySchedule;
export const createClinicScheduleController =
  apiClinicScheduleFp.clinicScheduleControllerCreate;
export const createWeeklyScheduleController =
  apiClinicScheduleFp.clinicScheduleControllerCreateWeeklySchedule;
export const updateClinicScheduleController =
  apiClinicScheduleFp.clinicScheduleControllerEdit;
export const deleteClinicScheduleController =
  apiClinicScheduleFp.clinicScheduleControllerDelete;

export const QueryKeyClinicSchedule = QueryKey.ClinicSchedule;
